import { memo } from "react";
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import EditIcon from '@mui/icons-material/Edit';
import LockIcon from '@mui/icons-material/Lock';
import When from "ui/support/When";
import { ReviewableAction, useActionContext } from "../../providers";

const Edit = () => {
    const {
        edit,
        hasAction,
        reset
    } = useActionContext();

    return (
        <ListItem
            disablePadding
        >
            <When
                if={!hasAction(ReviewableAction.Edit)}
                then={() => (
                    <ListItemButton
                        onPointerDown={edit}
                    >
                        <ListItemIcon>
                            <EditIcon />
                        </ListItemIcon>
                        <ListItemText
                            primary='Edit'
                        />
                    </ListItemButton>
                )}
                else={() => (
                    <ListItemButton
                        onPointerDown={() => reset(ReviewableAction.Edit)}
                    >
                        <ListItemIcon>
                            <LockIcon />
                        </ListItemIcon>
                        <ListItemText
                            primary='Lock Edit'
                        />
                    </ListItemButton>
                )}
            />
        </ListItem>
    );
};

export default memo(Edit);
